import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { InfoAboutFinishedScaffolding } from '../../../api';
import LabelAndTextBox from '../../molecules/labelandtextbox/LabelAndTextBox';
import './InfoAboutFinishedScaffolding.css';

interface InfoAboutFinishedScaffoldingProp {
  infoAboutFinishedScaffolding: InfoAboutFinishedScaffolding;
  isWeatherProtectionProject?: boolean;
}

const InfoAboutFinishedScaffoldingSection: React.FC<InfoAboutFinishedScaffoldingProp> = (props) => {
  return (
    <Container className='align-items-center tablecolor'>
      <Row>
        <Col xs={12} md={6} lg={12}>
          <div className='header-section-3 mb-5'>
            <h4>3. Uppgifter om den färdiga ställningen/väderskyddet</h4>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6} lg={12}>
          <div className='checkboxes1'>
            <input type="checkbox" defaultChecked={props.infoAboutFinishedScaffolding?.facadeScaffold}
              onChange={() => {
                if (props.infoAboutFinishedScaffolding.facadeScaffold === false) {
                  props.infoAboutFinishedScaffolding.facadeScaffold = true;
                }
                else if (props.infoAboutFinishedScaffolding.facadeScaffold === true) {
                  props.infoAboutFinishedScaffolding.facadeScaffold = false;
                }
              }} />
            <label>Fasadställning</label>
            <br />
            <input type="checkbox" defaultChecked={props.infoAboutFinishedScaffolding?.rolLScaffold}
              onChange={() => {
                if (props.infoAboutFinishedScaffolding.rolLScaffold === false) {
                  props.infoAboutFinishedScaffolding.rolLScaffold = true;
                }
                else if (props.infoAboutFinishedScaffolding.rolLScaffold === true) {
                  props.infoAboutFinishedScaffolding.rolLScaffold = false;
                }
              }} />
            <label>Rullställning</label>
            <br />
            <input type="checkbox" defaultChecked={props.infoAboutFinishedScaffolding?.weatherScaffold}
              onChange={() => {
                if (props.infoAboutFinishedScaffolding.weatherScaffold === false) {
                  props.infoAboutFinishedScaffolding.weatherScaffold = true;
                }
                else if (props.infoAboutFinishedScaffolding.weatherScaffold === true) {
                  props.infoAboutFinishedScaffolding.weatherScaffold = false;
                }
              }} />
            <label>Väderskydd</label>
            <br />
            <LabelAndTextBox title='Annan typ av ställning(ange vilken)' remark={props.infoAboutFinishedScaffolding?.otherStallningName}
              onChange={(value) => {
                props.infoAboutFinishedScaffolding.otherStallningName = value;
              }} />
          </div>
        </Col>
        <Col xs={12}>
          <LabelAndTextBox
            title='Prefabricerad ställning (ange fabrikat och typ)'
            remark={props.infoAboutFinishedScaffolding?.prefabricatedScaffold}
            placeholder={props.isWeatherProtectionProject ? 'Ange fabrikat och typ (obligatoriskt)' : undefined}
            onChange={(value) => {
              props.infoAboutFinishedScaffolding.prefabricatedScaffold = value;
            }}
          />
        </Col>
        <Col xs={12}>
          <LabelAndTextBox title='Rörställning (ange vilket typfall)' remark={props.infoAboutFinishedScaffolding?.pipeScaffold}
            onChange={(value) => {
              props.infoAboutFinishedScaffolding.pipeScaffold = value;
            }} />
        </Col>
        <Col xs={12}>
          <div className='paragraf-header mt-5'>
            <h4 className='mb-4'>Övriga uppgifter om ställningen:</h4>
          </div>
        </Col>
        <Col xs={12}>
          <LabelAndTextBox
            title='Lastklass'
            remark={props.infoAboutFinishedScaffolding?.loadClass?.toString()}
            onChange={(value) => {
              const intValue = parseInt(value);
              if (!isNaN(intValue)) {
                if (props.infoAboutFinishedScaffolding) {
                  props.infoAboutFinishedScaffolding.loadClass = intValue;
                }
              }
            }}
          />
        </Col>
        <Col xs={12}>
          <LabelAndTextBox title='Tillträdesled' remark={props.infoAboutFinishedScaffolding?.accessPoint}
            onChange={(value) => {
              props.infoAboutFinishedScaffolding.accessPoint = value;
            }} />
        </Col>
        <Col xs={12}>
          <LabelAndTextBox title='Höjd' remark={props.infoAboutFinishedScaffolding?.height}
            onChange={(value) => {
              props.infoAboutFinishedScaffolding.height = value;
            }} />
        </Col>
        <Col xs={12}>
          <LabelAndTextBox title='Bredd' remark={props.infoAboutFinishedScaffolding?.width}
            onChange={(value) => {
              props.infoAboutFinishedScaffolding.width = value;
            }} />
        </Col>
        <Col xs={12}>
          <LabelAndTextBox title='Väderskydd (beskrivning)' remark={props.infoAboutFinishedScaffolding?.weatherProtectionDescription}
            onChange={(value) => {
              props.infoAboutFinishedScaffolding.weatherProtectionDescription = value;
            }} />
        </Col>
        <Col xs={12}>
          <LabelAndTextBox title='Väderskyddets storlek (yta och höjd)' remark={props.infoAboutFinishedScaffolding?.weatherProtectionSize}
            onChange={(value) => {
              props.infoAboutFinishedScaffolding.weatherProtectionSize = value;
            }} />
        </Col>
      </Row>
      <hr />
    </Container>
  );
};

export default InfoAboutFinishedScaffoldingSection;
